import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import { Instagram, Tiktok, Youtube, BoxArrowUpRight } from 'react-bootstrap-icons'
import { toastError } from '../../../../../FormComponents/Toasts'
import axiosService from '../../../../../../utils/AxiosService'
import { formatNumber, socialPlatformLink } from '../../../../../../utils/Helper'
import ProfileDetails from './ProfilePageParts/ProfileDetails'
import Authentication from '../../../../../../models/Authentication'

export default observer(function ProfilePage({ auth }) {

  const [authentications, setAuthentications] = useState([])
  const [selectedAuthProfile, setSelectedAuthProfile] = useState(null)

  const getAuthentications = () => {
    axiosService.get(`/api/advertiser/campaign_share/authentications/${auth.authentication_id}/authentications`)
      .then(authentications => {
        const mappedAuthentications = authentications.map(authentication => new Authentication(authentication))
        setAuthentications(mappedAuthentications)
        setSelectedAuthProfile(mappedAuthentications[0])
      })
      .catch(({ data: { error } }) => toastError(error))
  }

  useEffect(() => { if (auth?.authentication_id) { getAuthentications() } }, [auth?.authentication_id])

  return (
    <div className='h-full flex flex-col'>
      <div className='flex-none'>
        <div className="p-5 m-7 bg-rb-grey rounded-xl">
          <div className="flex items-center gap-2">
            <img src={auth.avatar} alt="avatar" className="w-24 h-24 rounded-2xl" />
            <div className="flex flex-col justify-between">
              <div className="flex gap-3 items-center">
                <div className="flex items-center">
                  {auth.country && getUnicodeFlagIcon(auth.country)}
                  <p className="text-sm ml-1">{auth.country}</p>
                </div>
              </div>
              <p className="text-lg font-bold">{auth.username}</p>
              <div className="flex items-center p-1 gap-2">
                {
                  authentications.length > 0 && authentications.map((authentication, index) => {
                    const provider = authentication.provider
                    return (
                      <div key={authentication.id} className="flex">
                        <div className="flex items-center gap-2 border-1 rounded-xl p-1" key={index}>
                          {provider === 'instagram' && <Instagram className="text-pink-500 text-sm"/>}
                          {provider === 'tiktok' && <Tiktok className="text-sm"/>}
                          {provider === 'youtube' && <Youtube className="text-sm text-[#FO3B3B]"/>}
                          <span className="text-sm text-rb-mat-grey font-semibold">{formatNumber(authentication.reach)}</span>
                        </div>
                        <button
                          onClick={() => window.open(socialPlatformLink(provider, authentication.username), '_blank', 'noopener,noreferrer')}
                        >
                          <BoxArrowUpRight className='ml-2 text-xs text-rb-green' />
                        </button>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
        <div className="p-7 pt-0 flex gap-2">
          {
            authentications.length > 0 && authentications.map((authentication, index) =>(
              <button
                key={index}
                className={`flex items-center gap-2 border-1 rounded-xl px-4 py-2 ${selectedAuthProfile?.id === authentication.id ? 'border-2 border-rb-green bg-rb-light-green' : 'border-rb-lite-grey'}`}
                onClick={() => setSelectedAuthProfile(authentication)}
              >
                {authentication.provider === 'instagram' && <Instagram className="text-pink-500 text-lg"/>}
                {authentication.provider === 'tiktok' && <Tiktok className="text-lg"/>}
                {authentication.provider === 'youtube' && <Youtube className="text-lg text-[#FO3B3B]"/>}
                <span className="text-sm text-rb-mat-grey font-semibold">{authentication.provider[0].toUpperCase() + authentication.provider.slice(1)}</span>
              </button>
            ))
          }
        </div>
      </div>
      <div className='overflow-y-auto'>
        {selectedAuthProfile && <ProfileDetails auth={selectedAuthProfile} />}
      </div>
    </div>
  )
})
